import React from 'react';
import { SummaryOfDisabilitiesDescription } from '../content/summaryOfDisabilities';

export const uiSchema = {
  'ui:title': <h3 className="vads-u-margin-top--0">Review your conditions</h3>,
  'ui:description': SummaryOfDisabilitiesDescription,
};

export const schema = {
  type: 'object',
  properties: {},
};
